<template>
  <div class="dash-upload-more" :class="[size]">
      <ul class="v-upload-list-all">
        <li v-for="(item, index) in imgUrl" :key="index" class="v-upload-list__item">
        <template v-if="item.dataUrl">
          <div class="v-upload-list__item-img flex flex-start">
              <div class="v-upload-list__item_img">
                  <img v-if="item.dataType === 'WORD'" :src="WORD" class="iconImg" />
                  <img v-if="item.dataType === 'PPT'" :src="PPT" class="iconImg" />
                  <img v-if="item.dataType === 'PDF'" :src="PDF" class="iconImg" />
                  <img v-if="item.dataType === 'EXCEL'" :src="EXCEL1" class="iconImg" />
                  <img v-if="item.dataType === 'IMAGE'" :src="IMAGE" class="iconImg" />
                  <img v-if="item.dataType === 'VIDEO'" :src="VIDEO" class="iconImg" />
                  
              </div>
              <div class="v-upload-list__item_r">
                <div class="v-upload-list__item_text ellipsis-2 ">
                    {{item.dataName}}
                </div>
                <div class="v-upload-list__item-actions">
                    <span
                    v-if="editFailName"
                    class="el-upload-list__item-todo"
                    :class="{'disabled': loadingStatus}"
                    @click="editFail(item,index)">{{ $t('Modify file name') }}</span>
                    <span
                    class="el-upload-list__item-todo"
                    :class="{'disabled': loadingStatus}"
                    @click="del(item,index)">{{ $t('del') }}</span>
                </div>
              </div>
          </div>
        </template>
        </li>
        <el-upload
          class="v-upload-more"
          action=""
          :ref="uploadAddName"
          v-loading="loadingStatus"
          v-show="fileList.length < limit && uploadBtn"
          list-type="picture-card"
          :multiple="true"
          :limit="limit"
          :class="{'picture-uploader-disabled': disabled}"
          :disabled="disabled"
          :file-list="fileList"
          :show-file-list="false"
          :accept="fileType"
          :http-request="uploadPicture"
          :before-upload="beforeUpload"
          :on-exceed="onExceed"
          :on-change="onChange">
            <i slot="default" class="el-icon-plus"></i></el-upload> 
      </ul>
      <el-upload
        class="v-upload-more"
        action=""
        :ref="uploadAddName"
        v-loading="loadingStatus"
        v-show="fileList.length < limit && uploadBtn"
        list-type="picture-card"
        :multiple="true"
        :limit="limit"
        :class="{ 'picture-uploader-disabled': disabled }"
        :disabled="disabled"
        :file-list="fileList"
        :show-file-list="false"
        :accept="fileType"
        :http-request="uploadPicture"
        :before-upload="beforeUpload"
        :on-exceed="onExceed"
        :on-change="onChange"
      >
        <i slot="default" class="el-icon-plus"></i
      ></el-upload>
    <el-upload
      style="display: none"
      :ref="uploaderName"
      action=""
      :file-list="cFileList"
      :accept="fileType"
      :http-request="
        file => {
          uploadPicture(file, cIndex)
        }
      "
      :before-upload="
        file => {
          beforeUpload(file, cIndex)
        }
      "
    ></el-upload>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { 
  // exhibitorDataInsert,
  // exhibitorDataDelete,
  exhibitorDataUpdateName,
  // uploadOssByStream,
  uploadOssByStream,
  // importEmail, 
} from '@/api/index'
import WORD from '../assets/images/exhInfo/word.png'
import PPT from '../assets/images/exhInfo/ppt.png'
import PDF from '../assets/images/exhInfo/pdf.png'
import EXCEL from '../assets/images/exhInfo/excel.png'
import EXCEL1 from '../assets/images/exhInfo/excel1.png'
import IMAGE from '../assets/images/exhInfo/jpg&png.png'
import VIDEO from '../assets/images/exhInfo/mp4&mov.png'
export default {
  name: 'dash-upload-more-all',
  data() {
    return {
        WORD:WORD,
        PPT:PPT,
        PDF:PDF,
        EXCEL:EXCEL,
        EXCEL1: EXCEL1,
        IMAGE:IMAGE,
        VIDEO:VIDEO,

        media: '',
        loading: false,
        imgUrl: [],
        fileType: '',
        imgLoading: [],
        fileList: [],
        cIndex: 0,
        cFileList: [],
        uploadAddName: 'upload_' + parseInt(Math.random() * 100000000).toString() + '_' + Date.now(),
        uploaderName: 'uploader_' + parseInt(Math.random() * 100000000).toString() + '_' + Date.now()
    }
  },

  props: {
    // 上传文件的类型
    accept: {
      default: 'image/jpg,image/jpeg,image/png,image/gif',
      type: String
    },
    // 上传媒体类型： picture / video
    // media: {
    //   type: String,
    //   default: ''
    // },
    // 功能文字位置： bottom / right
    layout: {
      type: String,
      default: 'bottom'
    },
    //尺寸： small / medium / large / square
    size: {
      type: String,
      default: 'small'
    },
    // 已上传文件路径
    mediaUrl: {
      type: Array,
      default: () => {
        return []
      }
    },
    // 是否不可编辑
    disabled: {
      type: Boolean,
      default: false
    },
    uploadBtn: {
      type: Boolean,
      default: true
    },
    limit: {
      type: Number,
      default: 9
    },
    types: {
      type: String,
      default: ''
    },
    fit: {
      type: String,
      default: 'contain'
    },
    editFailName: {
      type: Boolean,
      default: true
    },
    fileUrl: {
      type: String,
      default: ''
    }
  },

  watch: {
    mediaUrl: function() {
      this.init()
    }
  },

  computed: {
    loadingStatus() {
      let list = this.imgLoading.filter(item => {
        return item === true
      })
      return list.length == 0 ? false : true
    },
    ...mapGetters(['language', 'info']),
  },

  mounted() {
    this.fileType = this.accept
    this.init()
  },

  methods: {
    init() {
      this.imgUrl = this.mediaUrl || []
      if (typeof this.imgUrl == 'string') {
        this.imgUrl = this.imgUrl.split(',')
      }
      let list = []
      this.imgUrl.forEach(item => {
          if(item.dataUrl!=undefined) {
              list.push({ url: item.dataUrl })
          }
      })
      this.fileList = list

    },
    uploadPicture(req, index) {
      const reader = new FileReader()
      const iIndex = index === undefined ? this.selectLen - 1 : index
      reader.readAsDataURL(req.file)
      reader.onload = () => {
        // 这个地方，可以得到 选中了文件的数据量
        // 获取文件名
        function getType(file) {
          var filename = file
          var index1 = filename.lastIndexOf('.')
          var index2 = filename.length
          var type = filename.substring(index1, index2)
          var name = parseInt(Math.random() * 100000000).toString()
          return [name, type]
        }

        // 文件上传失败的方法
        // function rError() {
        //   this.imgUrl[iIndex] = ''
        // }

        let names = getType(req.file['name'])[0].replace(/,/g, '')
        let params = {
          bucketName: 'ef-imaster-file',
          objectName: 'xiezhan/' + names[0] + '_' + new Date().valueOf() + names[1],
          baseStr: reader.result.split(',')[1],
          bizType: 'IMAGEFILE'
        }

        // 视频参数
        let config = {}
        if (this.media === 'video') {
          params.bucketName = 'ef-imaster-file'
          config.onUploadProgress = progressEvent => {
            let percent = ((progressEvent.loaded / progressEvent.total) * 100) | 0
            //调用onProgress方法来显示进度条，需要传递个对象 percent为进度值
            console.log(percent, progressEvent)
          }
        }
        var formData = new FormData()
        var objectName = 'xiezhan/' + req.file['name'].slice(0,req.file['name'].lastIndexOf('.'))+ parseInt(Math.random() * 100000000).toString()+req.file['name'].slice(req.file['name'].lastIndexOf('.'))
        var dataName = req.file['name']
        formData.append('bucketName','ef-imaster-file')
        formData.append('objectName',objectName)
        formData.append('file',req.file)
        formData.append('bizType','IMAGEFILE')
        var fileType = req.file['type']
        console.log(this.types)
        console.log(fileType, dataName, iIndex)

        if (this.types === 'batchUploadExhibits' || this.types === 'inviteSend') {
          uploadOssByStream(formData, config).then(res => {
            console.log(res.data.data)
            this.$emit('update:fileUrl', res.data.data)
          })
        }
        //  else {
        //   importEmail(formData, config)
        //     .then(res => {
        //       if (!res.data.data) {
        //         this.imgUrl.splice(iIndex, 1)
        //         this.fileList.splice(iIndex, 1)
        //         this.cFileList = []
        //         this.$emit('update:mediaUrl', this.imgUrl)
        //         this.$notify.error({
        //           title: this.$t('tips'),
        //           message: this.$t('No valid data')
        //         });
        //         return
        //       }
        //       var obj = {}
        //       const PDF=['application/pdf']
        //       const IMAGE= ['image/jpeg','image/png','image/gif']
        //       const VIDEO = ['video/mp4','video/quicktime']
        //       const WORD = ['application/msword','application/vnd.openxmlformats-officedocument.wordprocessingml.document']
        //       const PPT = ['application/vnd.ms-powerpoint','application/vnd.openxmlformats-officedocument.presentationml.presentation']
        //       const EXCEL = ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet','application/vnd.ms-excel']
        //       if (IMAGE.indexOf(fileType) > -1) {
        //           obj = {
        //               dataType: 'IMAGE',
        //               dataUrl: dataName,
        //               dataName: dataName
        //           }
        //       } else if (PDF.indexOf(fileType) > -1) {
        //           obj = {
        //               dataType: 'PDF',
        //               dataUrl: dataName,
        //               dataName: dataName
        //           }
        //       } else if (VIDEO.indexOf(fileType) > -1) {
        //           obj = {
        //               dataType: 'VIDEO',
        //               dataUrl: dataName,
        //               dataName: dataName
        //           }
        //       } else if (WORD.indexOf(fileType) > -1) {
        //           obj = {
        //               dataType: 'WORD',
        //               dataUrl: dataName,
        //               dataName: dataName
        //           }
        //       } else if (PPT.indexOf(fileType) > -1) {
        //           obj = {
        //               dataType: 'PPT',
        //               dataUrl: dataName,
        //               dataName: dataName
        //           }
        //       } else if (EXCEL.indexOf(fileType) > -1) {
        //           obj = {
        //               dataType: 'EXCEL',
        //               dataUrl: dataName,
        //               dataName: dataName
        //           }
        //       }
                          
        //         var resData = res.data.data || []
        //         var dataArr = []
        //         if(resData != 0) {
        //           for(let i in res.data.data) {
        //             if(res.data.data[i]['name'] && res.data.data[i]['email']) {
        //               dataArr.push(res.data.data[i])
        //             }
        //           }
        //         }
        //         obj['data'] = dataArr
        //         if(dataArr.length == 0) {
        //           this.$notify.error({
        //             title: this.$t('tips'),
        //             message: this.$t('No valid data')
        //           });
        //           this.imgUrl.splice(iIndex, 1)
        //           this.fileList.splice(iIndex, 1)
        //           this.cFileList = []
        //           this.$emit('update:mediaUrl', this.imgUrl)
        //         } else {
        //           this.$set(this.imgUrl, iIndex, obj)
        //           this.$emit('update:mediaUrl', this.imgUrl)
        //         }
        //     })
        //     .catch(() => {
        //       this.imgUrl.splice(iIndex, 1)
        //       this.fileList.splice(iIndex, 1)
        //       this.cFileList = []
        //       this.$emit('update:mediaUrl', this.imgUrl)
        //     })
        // }

      }
    },

    changeLoading(index, status) {
      this.loading = status
      if (this.curSelectNum != 0 && index === undefined) {
        this.$set(this.imgLoading, this.selectLen - 1, status)
      } else if (index || index === 0) {
        this.$set(this.imgLoading, index, status)
      }
    },

    beforeUpload(file, index) {
      this.changeLoading(index, true)
      if (this.media === 'picture') {
        const isLt2M = file.size / 1024 / 1024 < 10
        if (!isLt2M) {
          this.changeLoading(index, false)
          this.$message.error(this.$t('Uploaded image can not greater than 10Mb'))
        }
        return isLt2M
      }

      if (this.media === 'video') {
        const isLt = file.size / 1024 / 1024 < 10
        if (!isLt) {
          this.changeLoading(index, false)
          this.$message.error(this.$t('Uploaded video can not greater than 10Mb'))
        }
        return isLt
      }
    },

    onChange(file, fileList) {
        if(file['raw']['type'].split('/')[0] === 'image') {
            this.media = 'picture'
        } else if (file['raw']['type'].split('/')[0] === 'video') {
            this.media = 'video'
        } else if (file['raw']['type'].split('/')[0] === 'application') {
            this.media = 'application'
        }
        
        if (this.media === 'picture') {
            const isLt2M = file.size / 1024 / 1024 < 10
            if (isLt2M) {
                this.imgUrl.push(file.name)
                fileList[0]['type'] = 'IMAGE'
            }
        } else {
          const isLt2M = file.size / 1024 / 1024 < 10
          if (isLt2M) {
            this.imgUrl.push(file.name)
          }
        }
        this.fileList = fileList
        this.selectLen = fileList.length
    },

    onExceed() {
      this.$message.error(this.$t('uploadTips3') + this.limit)
    },

    triggerUpload(index) {
      this.cIndex = index
      this.$refs[this.uploaderName].$refs['upload-inner'].$refs['input'].click()
    },

    uploadAdd() {
      this.$refs[this.uploadAddName].$refs['upload-inner'].$refs['input'].click()
    },

    editFail(item) {
        this.$prompt(this.$t('Please enter a file name'), this.$t('tips'), {
          confirmButtonText: this.$t('ok'),
          cancelButtonText: this.$t('cancel'),
          inputPattern: /\s*\S+?/,
          inputErrorMessage: this.$t('filename is incorrect')
        }).then(({ value }) => {
          var dataName = value+item['dataName'].slice(item['dataName'].lastIndexOf('.'))
          let params = {
            id: item.id,
            dataName: dataName
          }
          exhibitorDataUpdateName(params).then(()=>{
            this.$message({
              type: 'success',
              message: this.$t('Revise Success')
            });
            item['dataName'] = dataName
          })
        })
    },
    del(item,index) {
      this.$confirm(this.$t('This will permanently delete the file. Continue?'), this.$t('tips'), {
        confirmButtonText: this.$t('ok'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning'
      }).then(() => {
          // let params = {
          //   id: item.id
          // }
          // exhibitorDataDelete(params).then((res)=>{
            // if(res.data.code === 1000) {
              this.$message({
                type: 'success',
                message: this.$t('Delete completed')
              });
              this.imgUrl.splice(index, 1)
              this.fileList.splice(index, 1)
              this.cFileList = []
              this.$emit('update:mediaUrl', this.imgUrl)
            // }
          // })
        })
    }
  }
}
</script>
<style lang="stylus">
.large {
  .v-upload-list-all .v-upload-list__item-img {
    width: 1000px;
    height: 560px;
    border: none;
  }
}
.v-upload-list-all {
    display: inline-block;
    vertical-align: top;

    .v-upload-list__item {
      display: inline-block;
      margin: 0 16px 16px 0;
      vertical-align: top;
    }
    .v-upload-list__item-img {
      width: 198px;
      height: 198px;
      border: 1px solid $color-white;
      overflow: hidden;
      background $color-white

      .el-image,
      .picture {
        width: 100%;
        height: 100%;
      }
    }

    .v-upload-list__item-actions {
      margin-top: 8px;
      line-height: 20px;
      font-size: 13px;
      color: $color-main;
      text-align: right;

      .el-upload-list__item-todo {
        cursor pointer
        & + .el-upload-list__item-todo{
          margin-left: 12px;
        }
      }
    }
}



  &.exhinfo {
      background $color-gray-fb
      // margin 0px 20px;
    .el-upload--picture-card {
      width: 300px;
      height: 120px;
      line-height 120px;

    }
  }



.exhinfo {
  .v-upload-list-all {
    .v-upload-list__item-img {
       width: 300px;
       height: 120px;
       border: 1px solid #fff;
        overflow: hidden;
        background: #fff;
    }
  }
}

.v-upload-list__item_img{
    min-width: 50px;
    max-width: 50px;
    height: 65px;
    margin 28px 6px 27px 6px
    img{
        width 100%
        height 100%
    }
}
.v-upload-list__item_r{
    height: 120px;
    width 225px;
    background $color-white
}
.v-upload-list__item_text{
    height: 50px;
    margin 28px 6px 0px 6px
    line-height 25px
}
</style>
